export const splitWordIntoParts = (word: string, slices = 2) => {
  if (word.length <= 1 || slices <= 1) return [word];

  const partSize = Math.ceil(word.length / slices);

  return Array.from({ length: slices }, (_, i) => word.slice(i * partSize, (i + 1) * partSize)).filter((part) => part); // Removes empty parts if any
};

export const pdfWordSplitter = (word: string) => {
  if (word.length < 16) {
    return [word];
  }

  if (word.length > 60) {
    return word.split('');
  }

  if (word.length > 40) {
    return splitWordIntoParts(word, 3);
  }

  return splitWordIntoParts(word);
};
